/**
 * Infrastructure: Vue Analytic Plan Editor Screen Data
 *
 * Vue-specific implementation of AnalyticPlanEditorScreenData.
 * This object is typically made reactive by Vue and used as the data source for components.
 *
 * Key features:
 * - Stores company configuration and lines
 * - Updates trigger Vue reactivity for UI updates
 * - Provides utility methods for line management
 *
 * @module analitic_accounting/infra/VueAnalyticsPlanEditorScreenData
 */

import { AnalyticPlanEditorScreenData } from "../domain/AnalyticsPlanEditorScreenData";
import { Company, Line } from "../domain/Company";

/**
 * Vue-compatible implementation of screen data for analytic plan editor.
 * This class should be instantiated and made reactive by Vue (e.g., in component data()).
 */
export class VueAnalyticPlanEditorScreenData implements AnalyticPlanEditorScreenData {
    /** The company configuration (made reactive by Vue) */
    company: Company;

    /** Array of lines being edited (made reactive by Vue) */
    lines: Line[];

    /**
     * Creates the screen data with empty initial state
     */
    constructor() {
        console.log("blackraven - VueAnalyticPlanEditorScreenData - constructor");
        this.company = null;
        this.lines = [];
    }

    /**
     * Sets the company configuration.
     * Vue reactivity will trigger component re-renders.
     *
     * @param company - The company aggregate
     */
    setCompany(company: Company): void {
        console.log("blackraven - VueAnalyticPlanEditorScreenData - setCompany");
        this.company = company;
    }

    /**
     * Sets the lines array.
     * Creates a new array (spread operator) to ensure Vue reactivity.
     *
     * @param lines - Array of Line entities
     */
    setLines(lines: Line[]): void {
        console.log("blackraven - VueAnalyticPlanEditorScreenData - setLines: ", lines)
        this.lines = [...lines];
    }

    /**
     * Renumbers all lines sequentially starting from 0.
     * Useful after adding/removing lines to maintain consistent numbering.
     */
    reCountLines() {
        console.log("blackraven - VueAnalyticPlanEditorScreenData - reCountLines");
        this.lines.forEach((line, index) => {
            line.line_number = index;
        });
    }
}